// Shop-All combined quiz entry panel.
// Chip selection injects the chosen popup's unique class (quiz-popup-<type>) onto
// .collection-section-quiz. Opening is handled inside each quiz snippet: on Proceed
// click, the snippet whose class is currently injected opens its own popup (which
// runs its loadQuestion()). This file only manages selection + the injected class.

document.addEventListener('DOMContentLoaded', () => {
  const panel = document.querySelector('.collection-section-quiz');
  if (!panel) return;

  const selectors = panel.querySelector('.csq-selectors');
  if (!selectors) return;

  const TYPES = ['sunscreen', 'moisturizer', 'serum'];

  const setActiveType = (type) => {
    for (const t of TYPES) panel.classList.toggle(`quiz-popup-${t}`, t === type);
  };

  selectors.addEventListener('click', (event) => {
    const chip = event.target.closest('.csq-chip');
    if (!chip) return;

    for (const other of selectors.querySelectorAll('.csq-chip')) {
      const isTarget = other === chip;
      other.classList.toggle('is-selected', isTarget);
      other.setAttribute('aria-pressed', String(isTarget));
    }

    const quizType = chip.dataset.quizType;
    if (quizType) setActiveType(quizType);
  });
});